import React, { useState, useContext } from 'react';
import { Container, TextField, Button, Box, Typography, Alert, Backdrop, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../components/util/AuthContext';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setAuthenticated, setUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      setIsSaving(true);
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include', // 세션 쿠키를 전달하기 위함
        body: JSON.stringify({ username, password })
      });
      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setAuthenticated(data.authenticated);
        setUser(data.user);
        navigate('/');
      } else {
        const data = await response.json();
        setError(data.message || '로그인 실패');
      }
    } catch (err) {
      setError('로그인 중 오류 발생');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Container maxWidth="sm">
      {/* 로딩 백드롭 모달보다 Index값이 1 높아야 함 */}
      <Backdrop open={isSaving} sx={{ zIndex: theme => theme.zIndex.modal + 1, color: '#fff'}}>
        <CircularProgress color="inherit"/>
      </Backdrop>
      <Box display="flex" flexDirection="column" alignItems="center" mt={8}>
        <Typography variant="h4" component="h1" gutterBottom>
          로그인
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit} width="100%" mt={2}>
          <TextField
            label="아이디"
            variant="outlined"
            margin="normal"
            fullWidth
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            label="비밀번호"
            type="password"
            variant="outlined"
            margin="normal"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
            로그인
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default LoginPage;
